module.exports = __webpack_public_path__ + "img/bgtop.60f475e9.jpg";